<template>
  <div class="">
    <div>
      <div class="px-8 pt-6 pb-6">
        <p class="text-xl font-bold mb-4 text-brand-black">Advanced Connection Settings</p>
        <p class="mb-3 text-brand-brown font-medium">
          <b>OAuth:</b> The easiest connection method. Recommended.
          <br />
          <b>Manual Connection:</b> For special use cases where OAuth is unavailable.
        </p>
        <!-- advanced settings here-->
        <!-- <p class="mt-4 mb-2 font-semibold text-sm font-gray-700">Connection Method</p> -->
        <el-switch v-model="manualConnectionValue" @change="toggleConnectionMode" active-text="Manual Connection" inactive-text="OAuth"></el-switch>

        <div v-if="manualConnectionValue">
          <p class="mt-4 mb-2 font-semibold text-sm font-gray-700">Stripe Account ID:</p>
          <el-input v-model="stripeAccountId" placeholder="Enter Stripe Account ID"></el-input>
        </div>
      </div>
      <!-- Cancel / Submit-->
      <div class="bg-brand-light-sand border-t-2 border-brand-sand flex justify-end px-4 py-4 rounded-b-lg">
        <el-button
          @click="
            close();
            reset();
          "
          type="plain"
          :disabled="isLoading"
          class="border-brand-gray-blue border-2 px-6 py-2 rounded-lg"
        >
          <span class="text-sm text-brand-blue font-semibold">Nevermind</span>
        </el-button>
        <el-button :disabled="!canSave" @click="save()" type="primary" class="font-bold py-2 px-6 rounded-lg text-sm" :loading="isLoading"
          >Save Settings</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { SET_ORG_DETAILS } from '../../store/mutation-types';
import OrgService from '../../api/org.service';

export default {
  data() {
    return {
      isLoading: false,
      manualConnectionValue: false,
      stripeAccountId: '',
    };
  },
  props: {
    close: {
      type: Function,
    },
  },
  created() {
    this.reset();
  },
  computed: {
    ...mapGetters(['currentOrgSettingsSaveState', 'orgProviderSettings']),
    org() {
      return this.$store.state.org || null;
    },
    orgId() {
      if (!this.org) return null;
      return this.org._id;
    },
    manualConnection() {
      return this.orgProviderSettings.manualConnection || false;
    },
    canSave() {
      const usingOAuth = !this.manualConnectionValue;
      const validAccountId = this.stripeAccountId && this.stripeAccountId.length > 5;
      const fieldsAreDefined = usingOAuth || validAccountId;
      const fieldsHaveChanged =
        this.manualConnectionValue !== this.orgProviderSettings.manualConnection ||
        (this.orgProviderSettings.manualConnection && this.stripeAccountId !== this.org.stripeAccountId);
      return fieldsAreDefined && fieldsHaveChanged && this.orgId;
    },
  },
  methods: {
    async reset() {
      if (!this.org) {
        await this.$store.dispatch('SYNC_USER_RECORD');
      }
      this.stripeAccountId = this.org.stripeAccountId || '';
      this.manualConnectionValue = this.orgProviderSettings.manualConnection || false;
    },
    toggleConnectionMode() {
      // changed mode
    },
    async save() {
      this.isLoading = true;
      this.savingProviderSettings = true;
      const update = {
        manualConnection: this.manualConnectionValue,
      };
      const newProviderSettings = { ...this.orgProviderSettings, ...update };
      this.$store.commit(SET_ORG_DETAILS, { providerSettings: newProviderSettings });
      await OrgService.update(this.orgId, { providerSettings: newProviderSettings });

      // Save stripeAccountId if needed
      if (this.manualConnectionValue && this.stripeAccountId) {
        await this.saveAccountId();
      }

      this.isLoading = false;
      this.$notify({ title: 'Manual Connection Settings Updated', type: 'success' });
      this.close();
    },
    async saveAccountId() {
      console.log('Saving...', this.stripeAccountId);
      try {
        this.isLoading = true;
        const result = await OrgService.saveStripeAccountId(this.orgId, this.stripeAccountId);
      } catch (error) {
        console.log('Error', error);
        this.$notify({ title: 'Stripe Account ID Update Failed', type: 'error' });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
